module.exports = __webpack_public_path__ + "static/flower_bg-584c298eb8d765a8d80683a86d15fab4.jpg";